import PropTypes from 'prop-types'

export const Style = ({ children, className, pseudo, attr, color }) => {
  const newClassName = className.replace(
    /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/gm,
    '\\$&',
  )
  return (
    <>
      {children}
      <style
        dangerouslySetInnerHTML={{
          __html: `.${newClassName}:${pseudo} { ${attr}: ${color} }`,
        }}
      />
    </>
  )
}

Style.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string.isRequired,
  pseudo: PropTypes.string.isRequired,
  attr: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
}
